import {RDate} from '@app/core/models/rDate.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';

export class PermanentlyEmployedSettings extends BaseModel {
	public id: number;
	public hours_per_month: number;
	public base_salary_per_month: number;
	public overtime_salary: number;
	public created_at: RDate;
	public updated_at: RDate;

	constructor(tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public deserialize(input: any): this {
		Object.assign(this, input);
		if (input.hours_per_month) {
			this.hours_per_month = input.hours_per_month;
		}
		if (input.base_salary_per_month) {
			this.base_salary_per_month = input.base_salary_per_month;
		}
		if (input.overtime_salary) {
			this.overtime_salary = input.overtime_salary;
		}

		return this;
	}
}
